import React from 'react';
import PropTypes from 'prop-types';

import { SCORE_SCALES } from '../constants/scoreScales';

const getScoreScale = score => (
  SCORE_SCALES.find(s => s.scale <= score)
);

const checkStatus = (status) => {
  let statusBool = false;
  switch (status) {
    case 'request_ctos_bad_request':
      statusBool = true;
      break;
    case 'request_ctos_muliple_entities':
      statusBool = true;
      break;
    default:
      statusBool = false;
  }
  return statusBool;
};

const CreditCheckScoreCTOS = ({
  mCtosXMLStatusID,
  ctosScore,
}) => {
  const scale = getScoreScale(ctosScore);
  return (
    <div className="score">
      <h1>CTOS SCORE</h1>
      {
        mCtosXMLStatusID !== 'dsr_generated' ?
          <div className={`${checkStatus(mCtosXMLStatusID) ? 'bad' : 'pending'} round icon`}>
            {
              checkStatus(mCtosXMLStatusID) ?
                <img alt="bad" src="/assets/images/icons/red_alert.svg" /> :
                <img alt="pending" src="/assets/images/icons/pending.svg" />
            }
          </div> :
          <div>
            <div className="success round icon" style={{ background: scale.color }}>
              <span className="value">{ctosScore}</span>
            </div>
            <h2 style={{ textTransform: 'uppercase', fontWeight: 'lighter' }}>
              {scale.title}
            </h2>
          </div>
      }
      {
        mCtosXMLStatusID === 'dsr_generated' &&
          <div className="breakdown">
            {
              SCORE_SCALES.map(score => (
                <div key={score.scale} className="breakdown-item">
                  <span className="indicator" style={{ background: score.color }} />
                  <div>
                    <h5>{score.title}</h5>
                    <p>{score.subtitle}</p>
                  </div>
                </div>
              ))
            }
          </div>
      }
    </div>
  );
};

CreditCheckScoreCTOS.propTypes = {
  mCtosXMLStatusID: PropTypes.string,
  ctosScore: PropTypes.string,
};

CreditCheckScoreCTOS.defaultProps = {
  mCtosXMLStatusID: 'new',
  ctosScore: '0',
};

export default CreditCheckScoreCTOS;



// WEBPACK FOOTER //
// ./src/components/CreditCheckScoreCTOS.jsx